<div class="" fxLayout="column" fxLayoutAlign="start center">
  <ng-container *ngIf="data.tipo == 'Recordatorios'">
    <ng-container *ngIf="data.recordatoriosFullInfo.length > 0">
      <h2 mat-dialog-title>{{'SHEDULE2_0.CARDS.PASO3.TIUTLOLISTA' | translate}}</h2>
      <mat-dialog-content class="mat-typography">
        <p><b>{{'SHEDULE2_0.CARDS.PASO3.INFOHORA' | translate}} {{horaInstitutoTag|date:"d MMM y H:mm":offsetPipe:idiomaActual}} ({{'SHEDULE2_0.ZONAS.'+data.instituto | translate}} {{horaInstitutoTag|date:'z':offsetPipe:idiomaActual}})</b></p>
        <mat-list class="tac">
          <mat-list-item *ngFor="let fecha of data.recordatoriosFullInfo; index as i; last as last">
            <mat-icon mat-list-icon>keyboard_arrow_right</mat-icon>
            <h4 mat-line>{{fecha.fechaRecordatorio|date:"d MMM y H:mm":offsetPipe:idiomaActual}} ({{fecha.fechaRecordatorio|date:'z':offsetPipe:idiomaActual}})</h4>
            <mat-form-field class="calHid">
                <input matInput [matDatepicker]="recordatorioFechas" [matDatepickerFilter]="filtroRecordatorios" (dateChange)="fechaRecordatorio(2, $event)">
                <mat-datepicker touchUi #recordatorioFechas></mat-datepicker>
            </mat-form-field>
            <div class="calHid">
                <input placeholder="12hr format (default settings)" aria-label="12hr format" [ngxTimepicker]="horaGenerica" [format]="24" id="timepickerRecosUpdat" readonly>
                <ngx-material-timepicker [enableKeyboardInput]="true" (timeSet)="horaSeleccionadaRecoUpdate($event)" [cancelBtnTmpl]="cancelBtn" [confirmBtnTmpl]="confirmBtn" [editableHintTmpl]="dialHint" #horaGenerica></ngx-material-timepicker>
                <ng-template #cancelBtn>
                    <button mat-raised-button color="accent" class="wsn m-20">{{'SHEDULE2_0.CARDS.FECHAS.BOTONES.CANCELAR' | translate}}</button>
                </ng-template>
                <ng-template #confirmBtn>
                    <button mat-raised-button color="accent" class="wsn m-20">{{'SHEDULE2_0.CARDS.FECHAS.BOTONES.ACEPTAR' | translate}}</button>
                </ng-template>
                <ng-template #dialHint>
                    <b class="fechaSel">{{'SHEDULE2_0.CARDS.FECHAS.FECHA' | translate}}{{fechaRecoTemp}}</b>
                </ng-template>
            </div>
            <button mat-mini-fab color="warn" class="margBtn" (click)="updRecordatorio(fecha, i)">
              <span class="material-icons-outlined">edit_calendar</span>
            </button>
            <button mat-mini-fab color="warn" (click)="borraRecordatorio(fecha.fechaRecordatorio, i)">
              <mat-icon>delete_forever</mat-icon>
            </button>
            <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
          </mat-list-item>
        </mat-list>
      </mat-dialog-content>
    </ng-container>
    <ng-container *ngIf="data.recordatoriosFullInfo.length == 0">
      <h2 mat-dialog-title>{{'SHEDULE2_0.CARDS.PASO3.NORECOS' | translate}}</h2>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="data.tipo == 'Avisos'">
    <ng-container *ngIf="data.avisosRegistrados.length > 0">
      <h2 mat-dialog-title>{{'SHEDULE2_0.CARDS.PASO3.TITU_AVIS' | translate}}</h2>
      <mat-dialog-content class="mat-typography">
        <p><b>{{'SHEDULE2_0.CARDS.PASO3.INFOHORAAVISO' | translate}} {{horaInstitutoTag|date:"d MMM y H:mm":offsetPipe:idiomaActual}} ({{'SHEDULE2_0.ZONAS.'+data.instituto | translate}} {{horaInstitutoTag|date:'z':offsetPipe:idiomaActual}})</b></p>
        <mat-list class="tac">
          <mat-list-item *ngFor="let fecha of data.avisosRegistrados; index as i; last as last">
            <mat-icon mat-list-icon>keyboard_arrow_right</mat-icon>
            <h4 mat-line>{{fecha.aviso|date:"d MMM y H:mm":offsetPipe:idiomaActual}} ({{fecha.aviso|date:'z':offsetPipe:idiomaActual}})</h4>
            <mat-form-field class="calHid">
                <input matInput [matDatepicker]="avisoFechas" [matDatepickerFilter]="filtroAviso" (dateChange)="fechaAviso(2, $event,fecha.aviso,i)">
                <mat-datepicker touchUi #avisoFechas></mat-datepicker>
            </mat-form-field>
            <div class="calHid">
                <input placeholder="12hr format (default settings)" aria-label="12hr format" [ngxTimepicker]="horaGenerica" [format]="24" id="timepickerAvisoUpdat" readonly>
                <ngx-material-timepicker [enableKeyboardInput]="true" (timeSet)="horaSeleccionadaAviUpdate($event)" [cancelBtnTmpl]="cancelBtn" [confirmBtnTmpl]="confirmBtn" [editableHintTmpl]="dialHint" #horaGenerica></ngx-material-timepicker>
                <ng-template #cancelBtn>
                    <button mat-raised-button color="accent" class="wsn m-20">{{'SHEDULE2_0.CARDS.FECHAS.BOTONES.CANCELAR' | translate}}</button>
                </ng-template>
                <ng-template #confirmBtn>
                    <button mat-raised-button color="accent" class="wsn m-20">{{'SHEDULE2_0.CARDS.FECHAS.BOTONES.ACEPTAR' | translate}}</button>
                </ng-template>
                <ng-template #dialHint>
                    <b class="fechaSel">{{'SHEDULE2_0.CARDS.FECHAS.FECHA' | translate}}{{fechaRecoTemp}}</b>
                </ng-template>
            </div>
            <button mat-mini-fab color="warn" class="margBtn" (click)="updFechaAviso(fecha, i)">
              <span class="material-icons-outlined">edit_calendar</span>
            </button>
            <button mat-mini-fab color="warn" (click)="borraAviso(fecha.aviso, i)">
              <mat-icon>delete_forever</mat-icon>
            </button>
            <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
          </mat-list-item>
        </mat-list>
      </mat-dialog-content>
    </ng-container>
    <ng-container *ngIf="data.avisosRegistrados.length == 0">
     <h2 mat-dialog-title>{{'SHEDULE2_0.CARDS.PASO3.NOAVI' | translate}}</h2>
    </ng-container>

  </ng-container>

  <button mat-raised-button color="accent" class="mt-20" (click)="salir()">
    {{'SHEDULE2_0.CERRAR' | translate}}
    <mat-icon class="ml-20">clear</mat-icon>
  </button>
</div>
